<template>
    <div>
        <div style="height: 2000px">博客</div>
    </div>
</template>

<script>
    export default {
        name: "Index"
    }
</script>

<style scoped>

</style>
